import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";

const listaParams = (obj) => {
  const result = obj.reduce((anterior, atual) => {
    if (atual.isChecked) {
      anterior.push(atual.codigo);
    }
    return anterior;
  }, []);
  return result;
};

const CheckBoxProcedimentos = ({ formik, field }) => {
  const [showErro, setshowErro] = useState(false);
  const [isVisible, setVisible] = useState(false);
  const [messageErro, setMessageErro] = useState("");
  const [procedimentos, setIProcedimentos] = useState([]);
  const [params, setParams] = useState([]);
  const [todosMarcados, setTodosMarcados] = useState(true);
  const { request, data, errors, isLoading } = useApiClient();

  const { values, setValues } = formik;
  const { nuTipoAcaoFiscal } = values;

  const selecaoInicial = useRef(values[field]?.length ? values[field] : null);

  useEffect(() => {
    if (nuTipoAcaoFiscal) {
      setVisible(nuTipoAcaoFiscal === "4" || nuTipoAcaoFiscal === "37" || nuTipoAcaoFiscal === "38");
      const obj = { sqTipoAcaoFiscal: nuTipoAcaoFiscal };
      request(apiRoutes.fiscalizacao.procedimentoFiscal.consultaProcedimentosPorAcaoAberta, obj);
    } else {
      setVisible(false);
    }
  }, [request, nuTipoAcaoFiscal]);

  useEffect(() => {
    if (data) {
      setshowErro(false);
      const selecao = selecaoInicial.current;
      selecaoInicial.current = null;
      const novaLista = data.result.map((item) => ({
        ...item,
        isChecked: selecao ? selecao.includes(item.codigo) : true,
      }));
      setIProcedimentos(novaLista);
      setTodosMarcados(novaLista.every((item) => item.isChecked));
    }
    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors]);

  useEffect(() => {
    if (procedimentos) {
      setParams(listaParams(procedimentos));
    }
  }, [procedimentos]);

  const marcarDesmarcarTodos = () => {
    const novoEstado = !todosMarcados;
    setIProcedimentos(procedimentos.map((item) => ({ ...item, isChecked: novoEstado })));
    setTodosMarcados(novoEstado);
    setParams(listaParams(procedimentos.map((item) => ({ ...item, isChecked: novoEstado }))));
  };

  const marcarDesmarcarItem = (codigo) => {
    const novosItens = procedimentos.map((item) =>
      item.codigo === codigo ? { ...item, isChecked: !item.isChecked } : item,
    );
    setIProcedimentos(novosItens);
    setParams(listaParams(novosItens));
    const todosMarcadosAgora = novosItens.every((item) => item.isChecked);
    setTodosMarcados(todosMarcadosAgora);
  };

  useEffect(() => {
    setValues((curr) => {
      const newValues = { ...curr, [field]: params };
      return newValues;
    });
  }, [setValues, field, params]);

  return (
    <>
      {showErro && (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {messageErro}
          </div>
        </>
      )}
      {isLoading ? (
        <TextSpinner />
      ) : (
        !showErro &&
        isVisible && (
          <>
            <Form.Label>Procedimentos</Form.Label>
            <br />
            <Form.Label>
              <input type="checkbox" checked={todosMarcados} onChange={marcarDesmarcarTodos} /> Todos
            </Form.Label>
            <ul>
              {procedimentos.map((item) => (
                <li key={item.codigo}>
                  <Form.Label>
                    <input type="checkbox" checked={item.isChecked} onChange={() => marcarDesmarcarItem(item.codigo)} />{" "}
                    {item.nome}
                  </Form.Label>
                </li>
              ))}
            </ul>
          </>
        )
      )}
    </>
  );
};

export default CheckBoxProcedimentos;
